import React, { useEffect, useState } from "react";
import "./Register.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "../../../utils/axios";
import { useGoogleLogin } from "@react-oauth/google";

import BaseDialog from "../../../modelDialogs/BaseDialog";
import { RequiredLabel, encrypt } from "../Login/Login";
import LanguagePicker from "../../../LanguagePicker";
import { itx, noItx } from "../../../translationItx/itx";
import { isDevelopmentEnvironment } from "../../../estada-config";
import { setSession, setUser } from "../auth-helper";
import { PhoneInputField } from "./PhoneInputField";
import { StrengthsSection } from "./StrengthsSection";
import OnboardingQuiz from "./OnboardingQuiz/OnboardingQuiz";
import { authRedirectTarget, type AuthLocationState } from "../auth-redirect";
import FullSceenButton from "../../FullscreenButton";

export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTarget = authRedirectTarget(location.state as AuthLocationState | null);
  const [selectedCountryCode, setSelectedCountryCode] = useState("+49"); // Default to Germany
  const [showOnboardingQuiz, setShowOnboardingQuiz] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");

  useEffect(() => {
    state._navigate = navigate;
    if (state.loggedInUser && state.loggedInUser != "no") {
      navigate(redirectTarget, { replace: true });
    }
  }, []);
  //const newRegexPhone = new RegExp();
  const registerSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, state.translate("register.PasswordMinLength", "Password: Minimum 8 characters."))
      .required(state.translate("register.passwordEnter", "Please enter Password!")),
    email: Yup.string()
      .email(state.translate("register.emailInvalid", "Invalid email"))
      .required(state.translate("register.emailrequired", "Email is Required!")),
    name: Yup.string()
      .trim()
      .min(3, state.translate("register.nameLength", "Name must have 3 characters."))
      .required(state.translate("register.enterFullName", "Please enter full name!")),
    phone: Yup.string()
      .matches(
        /^(\+49|0)[\s\-]?[1-9][0-9\s\-\/]{6,14}[0-9]$|^(?=(?:[\+\s\-\.\(\)]*\d){7,})\+?[1-9][0-9]{0,3}([\s\-\.]?[0-9]{1,6}){2,7}$/im,
        state.translate("register.phoneInvalid", "Invalid phone number"),
      )
      .required(state.translate("register.enterPhone", "Please enter phone number!")),
    company_name: Yup.string(),
    vat: Yup.string().min(9, state.translate("register.vatLength", "VAT must have 9 characters.")),
    privacyPolicy: Yup.bool().oneOf(
      [true],
      state.translate("register.acceptTermsAndConditions", "Please accept terms and conditions!"),
    ),
  });

  const handleSubmit = async (values: any, { setSubmitting, setErrors }: any) => {
    setSubmitting(true);

    // Spam validation before API call-> stillgelegt 22.04.2026 zu viele meldungen die sich nicht anmelden können

    // const validationResult = await validateRegistration({
    //   email: values.email,
    //   name: values.name,
    //   phone: values.phone,
    //   company_name: values.company_name,
    //   vat: values.vat,
    // });

    // if (!validationResult.isValid && !isDevelopmentEnvironment() ) {
    //   // skip this validation because of problems with register of users
    //   // Show validation errors
    //   const errorMessage = validationResult.errors.join("\n");
    //   setErrors({
    //     email: errorMessage,
    //   });

    //   state.dialogManager.openDialog(
    //     <BaseDialog
    //       className="dialog-standard"
    //       title={state.translate("register.registrationNotAccepted", "Registrierung wurde nicht akzeptiert")}
    //       onOk={() => {
    //         return true;
    //       }}
    //       okCaption={state.translate("ok", "Ok")}
    //       noAbortButton={true}
    //     >
    //       <div style={{ padding: "20px" }}>{errorMessage}</div>
    //     </BaseDialog>,
    //   );

    //   setSubmitting(false);
    //   return;
    // }

    // if (isDevelopmentEnvironment()) {
    //   alert("Submitting registration... totgelegt für development"); // Remove or replace with proper loading indicator
    //   return;
    // }

    let payload = {
      ...values,
      password: encrypt(values.password),
    };
    const response = axios.post("/api/register", payload);
    response
      .then((result: any) => {
        let message = result.data.MESSAGE;
        if (
          result.data.MESSAGE ==
          "We have sent an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link."
        ) {
          message = state.translate(
            "register.messageSuccess",
            "Wir haben eine E-Mail mit einem Bestätigungslink an Ihre E-Mail-Adresse gesendet. Um den Anmeldevorgang abzuschließen, klicken Sie bitte auf den Bestätigungslink.",
          );
        }
        // first log in after registration
        const loginData = { email: values.email, password: encrypt(values.password) };
        axios
          .post("/api/login", loginData)
          .then((result: any) => {
            if (result.data.DATA.token) {
              // redirect to APP Dashboard
              const credentials = result.data.DATA;
              if (isDevelopmentEnvironment()) {
                //  credentials.abo = "development"; // no itx
              }

              // check here if abo is availiable

              setUser(JSON.stringify(credentials));
              setSession(credentials.token);
              state.isLoggedIn = true;
              (window as any).isEstadaLoggedIn = true;
              setRegisteredEmail(values.email);
              setShowOnboardingQuiz(true);
            }
          })
          .catch((e) => {
            navigate("/login", { state: { from: redirectTarget } });
          });

        return;
        state.dialogManager.openDialog(
          <BaseDialog
            className="dialog-standard"
            title={state.translate("Success", "Success")}
            onOk={() => {
              state.navigate("/login");
              return true;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ maxWidth: "400px" }}>{message}</div>
          </BaseDialog>,
        );
      })
      .catch((e) => {
        let failureMesssage: string = "";
        if (typeof e.DATA == `string`) {
          failureMesssage = e.DATA;
        } else {
          failureMesssage = e.MESSAGE;
        }
        const possibleFailureMessages = new Map<string, string>();
        possibleFailureMessages.set("emailAlreadyRegistered", "Email already registered!"); // no itx
        possibleFailureMessages.forEach((value, key) => {
          if (value == failureMesssage) {
            failureMesssage = state.translate(`register.${key}`, value);
          }
        });

        state.dialogManager.openDialog(
          <BaseDialog
            className="dialog-standard"
            title={state.translate("error", "Error")}
            onOk={() => {
              return true;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{failureMesssage}</div>
          </BaseDialog>,
        );
      })
      .finally(() => setSubmitting(false));
  };

  /**
   * Google Sign In
   */
  const googleSignIn = useGoogleLogin({
    onSuccess: (tokenResponse) => verifyGoogleUser(tokenResponse.access_token),
  });
  /**
   * Google Login token verify and Login
   * @param credentialResponse
   */
  const verifyGoogleUser = (credentialResponse: String) => {
    axios
      .post("/api/google/auth/login", { token: credentialResponse })
      .then((result: any) => {
        if (result.data.DATA.token) {
          // redirect to APP Dashboard
          navigate(redirectTarget, { replace: true });
        }
      })
      .catch((e) => {
        state.dialogManager.openDialog(
          <BaseDialog
            className="dialog-standard"
            title={state.translate("error", "Error")}
            onOk={() => {
              return true;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{e.DATA || e.message}</div>
          </BaseDialog>,
        );
      });
  };
  var offsetHeight = "100%";
  const elem = document?.getElementById("lView");
  if (elem) {
    offsetHeight = `${elem.offsetHeight}px`;
  }

  return (
    <div id="App" className="App">
      <FullSceenButton scope="registration" />
      <div className="Register main-form">
        <div className="lView" id="lView">
          <div className="head">
            <div className="logo" style={{ cursor: "default" }}>
              <img src={`${state.hostBaseUrl}images/logo.png`} />
              <span className="logoText">{noItx("ESTADA")}</span>
            </div>
            {!showOnboardingQuiz && (
              <span className="title form-title">
                {state.translate("register.createAccountText", "Create a new account")}
              </span>
            )}
            {/* <button onClick={() => googleSignIn()} className="confirm-button">
              <span>{state.translate("register.loginGoogle", "Log in with Google")}</span>
            </button> */}
            {isDevelopmentEnvironment() && !showOnboardingQuiz && (
              <button
                type="button"
                onClick={() => setShowOnboardingQuiz(true)}
                style={{
                  border: "1px dashed rgba(255,255,255,0.6)",
                  borderRadius: "20px",
                  padding: "6px 14px",
                  color: "#ffffff",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                [Dev] {itx("Register.QuizOhneReg", "Quiz ohne Registrierung testen")}
              </button>
            )}
          </div>
          {showOnboardingQuiz && (
            <OnboardingQuiz onComplete={() => navigate("/register-project", { replace: true })} email={registeredEmail} />
          )}
          {!showOnboardingQuiz && (
            <Formik
              initialValues={{
                email: "",
                password: "",
                name: "",
                phone: "",
                company_name: "",
                vat: "",
                subscribe: true,
                privacyPolicy: false,
              }}
              validationSchema={registerSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, submitCount, isValid }) => {
                return (
                  <Form>
                    <div className="inp">
                      <label className="field-container">
                        <span className="form-label">
                          {/* {state.translate("loginPage.email", "E-mail")} <RequiredLabel /> */}
                        </span>
                        <span className="form-span input-container">
                          <i className="la la-envelope la-lg input-icon" />
                          <Field
                            className="form-input input-field"
                            type="email"
                            name="email"
                            maxLength="255"
                            placeholder={""}
                          />
                          <label className="input-label">
                            {state.translate("loginPage.email", "Email")}
                            <RequiredLabel />
                          </label>
                        </span>

                        <ErrorMessage className="form-error" name="email" component="div" />
                      </label>
                      <label className="field-container">
                        <span className="form-label">
                          {/* {state.translate("register.fullName", "Full Name")} <RequiredLabel /> */}
                        </span>
                        <span className="form-span input-container">
                          <i className="la la-user la-lg input-icon" />
                          <Field
                            className="form-input input-field"
                            type="text"
                            name="name" // no itx
                            max
                            Length="255"
                            placeholder={""}
                          />
                          <label className="input-label">
                            {state.translate("register.fullName", "Full Name")}
                            <RequiredLabel />
                          </label>
                        </span>
                        <ErrorMessage className="form-error" name="name" component="div" />
                      </label>
                      <label className="field-container">
                        <span className="form-label">{}</span>
                        <PhoneInputField
                          name="phone" // no itx
                          selectedCountryCode={selectedCountryCode}
                          onCountryChange={(dialCode) => {
                            setSelectedCountryCode(dialCode);
                          }}
                        />
                        <ErrorMessage className="form-error" name="phone" component="div" />
                        {/* var regex = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
                      regex.test('+1 (615) 243-5172'); // returns true
                      check if given phone number is a real phone number*/}
                      </label>
                      <label className="field-container">
                        <span className="form-label">{/* {state.translate("register.company", "Company")} */}</span>
                        <span className="form-span input-container">
                          <i className="la la-building la-lg input-icon" />
                          <Field
                            className="form-input input-field"
                            type="text"
                            name="company_name" // no itx
                            maxLength="255"
                            placeholder={""}
                          />
                          <label className="input-label">{state.translate("register.company", "Company")}</label>
                        </span>
                        <ErrorMessage className="form-error" name="company_name" component="div" />
                      </label>
                      {/* <label>
                      <span className="form-label">{state.translate("register.vat", "VAT.")}</span>
                      <span className="form-span">
                        <Field className="form-input" type="text" name="vat" maxLength="9" />
                      </span>
                      <ErrorMessage className="form-error" name="vat" component="div" />
                    </label> */}
                      <label className="field-container">
                        <span className="form-label">
                          {/* {state.translate("loginPage.password", "Password")} <RequiredLabel /> */}
                        </span>
                        <span className="form-span input-container">
                          <i className="la la-lock la-lg input-icon" />
                          <Field
                            className="form-input input-field"
                            type="password" // no itx
                            name="password" // no itx
                            maxLength="64"
                            placeholder={""}
                          />
                          <label className="input-label">
                            {state.translate("loginPage.password", "Password")}
                            <RequiredLabel />
                          </label>
                        </span>
                        <ErrorMessage className="form-error" name="password" component="div" />
                      </label>
                    </div>

                    <div className="endItems">
                      <label className="privacyPolicy">
                        <span className="customCheckmark">
                          <Field
                            className="form-checkbox"
                            type="checkbox"
                            name="privacyPolicy" // no itx
                          />
                          <span className="checkmark" />
                        </span>
                        <span className="form-text">
                          <span style={{ fontWeight: "bold" }}>
                            {state
                              .translate("register.privacyPolicyText", " Ich stimme der T1 zu: ")
                              .substring(
                                0,
                                state.translate("register.privacyPolicyText", " Ich stimme der T1 zu: ").indexOf("T1"),
                              )}
                            <a
                              className="form-link"
                              href="https://estada.de/privacy-policy" // no itx
                              target="_blank" // no itx
                              rel="noreferrer noopener" // no itx
                            >
                              {state.translate("register.privacyPolicy", "Privacy Policy")}
                            </a>
                            {state
                              .translate("register.privacyPolicyText", " Ich stimme der T1 zu: ")
                              .substring(
                                state.translate("register.privacyPolicyText", " Ich stimme der T1 zu: ").indexOf("T1") +
                                  2,
                              )}
                            &nbsp;
                            <RequiredLabel />
                          </span>
                          <br />
                          <div style={{ fontSize: "10px", lineHeight: "15px" }}>{itx("register.textContact")}</div>
                        </span>
                      </label>
                      <div className="subscribe -align-left">
                        <ErrorMessage className="form-error" name="privacyPolicy" component="div" />
                      </div>
                      {submitCount > 0 && !isValid && (
                        <div className="form-error" style={{ marginBottom: "10px" }}>
                          {state.translate("register.fillRequiredFields", "Please fill in all required fields.")}
                        </div>
                      )}
                      <button
                        disabled={isSubmitting}
                        className="submit confirm-button button-full"
                        type="submit" // no itx
                      >
                        <span>{state.translate("register.createAccount", "Create Account")}</span>
                      </button>
                      <span className="info form-span">
                        {state.translate("register.accountAlreadyavailable?", "You already have an Account?")}{" "}
                        <Link to={"/login"} state={{ from: redirectTarget }} className="form-link">
                          {state.translate("loginPage.signIn", "Sign in!")}
                        </Link>
                        !
                      </span>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          )}
        </div>
        {!showOnboardingQuiz && (
          <div className="rView">
            <StrengthsSection />
          </div>
        )}
        <LanguagePicker className="language-picker" />
        {/* <DialogHost /> */}
      </div>
    </div>
  );
}
